import PersonWrapper from './PersonWrapper';

export default PersonWrapper;
